import {
} from '@/api/accesstokenserv'

export default {
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters:{
  }
}